<template>
  <div class="tab">
    <div class="type1" v-if="arrow?false:true">
      <div class="left">
        <img src="/static/img/top_arrow_b.png" alt @click="$router.go(-1)" />
      </div>
      <div class="title">{{title}}</div>
      <div class="right"></div>
    </div>
    <div class="type2" v-else>
      <div class="title">{{title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    arrow: String
  },
  created(){
  }
};
</script>

<style lang="scss" scoped >
.tab {
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 2;
  padding: 0 30px;
  .type1 {
    display: flex;
    height: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .left,
    .right {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      img {
        width: 18px;
        height: 32px;
      }
    }
  }
  .type2{
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .title {
    height: 50px;
    font-size: 36px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/tab/tab.vue